import React from "react";

export default function ArrowUpIcon() {
    return (
        <svg fill="#973794" height="8px" width="8px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 386.257 386.257" xmlSpace="preserve"
             transform="rotate(180)"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC"
               strokeWidth="1.545028"></g>
            <g id="SVGRepo_iconCarrier"> <polygon
                points="0,96.879 193.129,289.379 386.257,96.879 "></polygon> </g></svg>
    );
}